import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RouteBase } from '../routes/base';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient){

  }
  /**
   * 
   * Negócios
   * 
   */
  negocios(){

    return {
      list: (params:any):any => {

        let url = RouteBase.NEGOCIOS.list;

        
        return this.http.get(url,{params}); 

      },
      store: (params:any,foto:any):any => {

        let formData = new FormData();

        formData.append("nome",params.nome);
        formData.append("telefone",params.telefone);
        formData.append("empresa_nome",params.empresa_nome);
        formData.append("empresa_telefone",params.empresa_telefone);
        formData.append("empresa_servicos",params.empresa_servicos);
        formData.append("texto",params.texto);
        formData.append("observacao",params.observacao);
        formData.append("link_instagram",params.link_instagram);
        formData.append("link_facebook",params.link_facebook);
        formData.append("link_site",params.link_site);
        formData.append("empresa_endereco",params.empresa_endereco);
        formData.append("empresa_atuacao",params.empresa_atuacao);
        formData.append("membro_ano",params.membro_ano);
        formData.append("foto",foto);

        let url = RouteBase.NEGOCIOS.store;

        return this.http.post(url,formData); 

      }
    }

  }
  /***
   * 
   * Conteúdo
   * 
   */
  evento(){

    return {
      show: (apelido):any => {

        let url    = RouteBase.EVENTO.show+"/"+apelido;

        return this.http.get(url);  

      }
    }

  }
  /***
   * 
   * Conteúdo
   * 
   */
  conteudo(){

    return {
      page: (apelido):any => {

        let url    = RouteBase.CONTEUDO.page+"/"+apelido;

        return this.http.get(url);  

      }
    }

  }
  /***
   * 
   * Contato
   * 
   */
  contato(){

    return {
      fale_conosco: (params):any => {

        let url = RouteBase.MODULO.fale_conosco;
        return this.http.post(url,params); 

      },
      consultor: (params):any => {

        let url = RouteBase.MODULO.contato_consultor;
        return this.http.post(url,params); 

      },
      contato: (params):any => { 

        let url = RouteBase.MODULO.contato;
        return this.http.post(url,params); 

      },
      sugestao: (params):any => {

        let url = RouteBase.MODULO.contato_sugestao;
        return this.http.post(url,params); 

      }
    }

  }
  /**
   * 
   * Modulos
   * 
   */
  modulos(){

    return {
      getModulos: ():any => {

        let url = RouteBase.MODULO.modulos;
 
        return this.http.get(url);

      },
      newsletter: (params):any => {
        
        let url = RouteBase.MODULO.newsletter
        return this.http.post(url,params);
      
      }
    }

  }
  /**
   * 
   * Formata o erro da API
   * 
   */
  formatError(response){

    let error = {
      status: null,
      statusText: null,
      message: null
    }

    if(response.statusText){
      error.statusText = response.statusText;
    }
    if(response.status){
      error.status = response.status;
    }
    if(error.status == 405){
      error.message = "Método não permitido.";
    }
    if(response.error && error.message == null){
      
      let body = response.error;

      if(error.status == 422){

        error.message = this.formarErrorsValidation([body.errors]);

      }else if(body.message){
        error.message = body.message;
      }

    }else{
      error.message = response.data;
    }

    return error;


  }
  /**
   * 
   * Formata as mensagens de erro 
   * 
   * @param err 
   * @param paxs 
   * 
   */
  formarErrorsValidation(err,paxs=null){
    
    let messages = ""
    
    if(typeof(err) == "string"){
      messages = err
    }else{
      if(err.length > 1){
           
        for(let key in err) {
          if(paxs){
            let i = parseInt(key)+1 
            messages += "<h6>Passageiro: "+i+"<h6>"
          }
          for(let k in err[key]){
            messages += err[key][k]+"<br>"
          }
                   
        }
      }else{
        for(let key in err[0]) {
          messages += err[0][key]+"<br>"
        }
     }  
    
    }
    
    return messages;
    
  }
  
}
